import { useEffect, useState } from 'react'

const getInitial = (): boolean => {
  if (typeof navigator === 'undefined') return true
  return navigator.onLine
}

/**
 * Hook : true si le navigateur est connecté, false sinon.
 * S'appuie sur les événements `online` / `offline` du navigateur.
 */
export const useOnlineStatus = (): boolean => {
  const [online, setOnline] = useState<boolean>(getInitial)

  useEffect(() => {
    const onOnline = () => setOnline(true)
    const onOffline = () => setOnline(false)
    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)
    setOnline(navigator.onLine)
    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  return online
}
